<template>
  <div align="center">
    <br />
    <table
      width="80%"
      border="0"
      cellpadding="0"
      cellspacing="0"
      class="table_blue"
    >
      <tr>
        <td width="100%" height="98" align="center" valign="middle">
          {{ $t("norecord_word1") }}
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {};
</script>